import type { MessageInstance } from 'antd/es/message/interface'

let messageApi: MessageInstance | null = null

export function registerMessageApi(api: MessageInstance) {
  messageApi = api
}

export function getMessageApi(): MessageInstance | null {
  return messageApi
}
